export const paymentDictionary = {
  amount: 'Miqdori',
  paymentType: "To'lov turi",
  time: 'Vaqti',
  iStartDate: 'Boshlanish vaqti',
  endDate: 'Tugash vaqti',
  sum: " so'm",
}
